import React, { Component } from "react";
import { Table, Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import settings from "../../settings.js";
import ClientBadge from "../ClientBadge.js";
import "../../styles/retouren.css";

class RetourenLijst extends Component {
  constructor(props) {
    super(props);
    this.state = {
      retouren: [],
      total: 0,
      page: 1,
      limit: 10,
      modal: false,
      selectedRetour: null,
      filterType: "all", // Add new state for filter
    };
  }

  componentDidMount() {
    this.loadRetouren();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.activeTab !== this.props.activeTab &&
      this.props.activeTab === "1"
    ) {
      this.loadRetouren();
    }
  }

  loadRetouren() {
    this.props.loading(true);
    fetch(
      settings.server_url +
        "get_retouren/" +
        window.sessionStorage.getItem("sid")
    )
      .then((res) => res.json())
      .then((response) => {
        if (response.result && Array.isArray(response.returns)) {
          let filteredReturns = response.returns;

          // Apply filtering based on filterType
          switch (this.state.filterType) {
            case "action":
              // Filter returns requiring action (status 1 or 2)
              filteredReturns = response.returns.filter((r) =>
                ["1", "2"].includes(r.return_status)
              );
              break;
            case "active":
              // Filter active returns (status not 9/completed)
              filteredReturns = response.returns.filter(
                (r) => r.return_status !== "9"
              );
              break;
            default:
              // 'all' - no filtering needed
              break;
          }

          this.setState({
            retouren: filteredReturns,
            total: response.total,
            page: response.page,
            limit: response.limit,
          });
        } else {
          this.setState({ retouren: [] });
        }
        this.props.loading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState({ retouren: [] });
        this.props.loading(false);
      });
  }

  getStatusText(status) {
    switch (status) {
      case "1":
        return "In behandeling";
      case "2":
        return "Wacht op beoordeling";
      case "3":
        return "Retour afgekeurd";
      case "4":
        return "Gereed";
      default:
        return "Onbekend";
    }
  }

  getStatusColor(status) {
    switch (status) {
      case "1":
        return "text-info";
      case "2":
        return "text-warning";
      case "3":
        return "text-danger";
      case "4":
        return "text-success";
      default:
        return "";
    }
  }

  handleNewRetour = () => {
    this.props.onTabChange("2");
  };

  toggleModal = (retour = null) => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
      selectedRetour: retour,
    }));
  };

  getReturnLabelLink(returnId) {
    return (
      settings.server_url +
      "get_pdf_return_label/" +
      window.sessionStorage.getItem("sid") +
      "/" +
      returnId
    );
  }

  renderStatusTimeline() {
    const { selectedRetour } = this.state;
    if (!selectedRetour) return null;

    const getStatusClass = (status, currentDate, deniedStatus, inTransit) => {
      if (deniedStatus) return "denied";
      if (inTransit) return "in-transit";
      if (currentDate) return "completed";
      return "pending";
    };

    const statuses = selectedRetour.statuses.map((status) => ({
      id: status.id,
      label: status.name,
      date: status.date,
      completed: status.completed,
      denied: status.name.toLowerCase().includes("afgekeurd"),
    }));

    return (
      <div className="status-timeline">
        {statuses.map((status, index) => (
          <div
            key={status.id}
            className={`status-item ${getStatusClass(
              status.id,
              status.date,
              status.denied,
              status.inTransit
            )}`}
          >
            <div className="status-node">
              {status.denied ? (
                <i className="fas fa-times"></i>
              ) : status.inTransit ? (
                <i className="fas fa-truck"></i>
              ) : (
                <i className="fas fa-check"></i>
              )}
            </div>
            <div className="status-content">
              <div className="status-label">{status.label}</div>
              {status.date && (
                <div className="status-date">
                  {new Date(status.date).toLocaleString("nl-NL", {
                    day: "numeric",
                    month: "short",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </div>
              )}
            </div>
            {index < statuses.length - 1 && <div className="status-line"></div>}
          </div>
        ))}
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2>Aangemelde retouren</h2>
          <div className="d-flex align-items-center flex-nowrap">
            <select
              className="custom-select"
              style={{ minWidth: "150px", marginRight: "10px" }}
              value={this.state.filterType}
              onChange={(e) => this.setState({ filterType: e.target.value })}
            >
              <option value="action">Actie vereist</option>
              <option value="active">Actieve retouren</option>
              <option value="all">Alle retouren</option>
            </select>
            <div
              className="search-container"
              style={{ minWidth: "200px", marginRight: "10px" }}
            >
              <input
                type="text"
                className="form-control"
                placeholder="Zoek artikel"
              />
            </div>
            <button
              className="btn btn-primary nowrap"
              onClick={this.handleNewRetour}
            >
              Nieuwe retour aanmelden
            </button>
          </div>
        </div>

        <Table hover className="retouren-table">
          {this.state.retouren.length > 0 ? (
            <>
              <thead>
                <tr>
                  <th width="120">Status</th>
                  <th>Product</th>
                  <th>Artikelnummer</th>
                  <th>Actie</th>
                  <th>Aantal</th>
                  <th>Eenheid</th>
                  <th>Datum</th>
                </tr>
              </thead>
              <tbody>
                {this.state.retouren.map((retour) => (
                  <tr
                    key={retour.return_id}
                    onClick={() => this.toggleModal(retour)}
                    style={{ cursor: "pointer" }}
                  >
                    <td>
                      <span
                        className={`badge ${(() => {
                          switch (retour.return_status) {
                            case "1":
                              return "bg-info text-white"; // STATUS_NEW - Nieuw
                            case "2":
                              return "bg-success text-white"; // STATUS_APPROVED - Goedgekeurd
                            case "3":
                              return "bg-danger text-white"; // STATUS_REJECTED - Afgekeurd
                            case "4":
                              return "bg-primary text-white"; // STATUS_LABEL_PRINTED - Label geprint
                            case "5":
                              return "bg-warning text-dark"; // STATUS_DRIVER_RECEIVED - Chauffeur ontvangen
                            case "6":
                              return "bg-success text-white"; // STATUS_FINAL_CHECK_APPROVED - Eindcontrole goedgekeurd
                            case "7":
                              return "bg-danger text-white"; // STATUS_FINAL_CHECK_REJECTED - Eindcontrole afgekeurd
                            case "8":
                              return "bg-purple text-white"; // STATUS_CREDIT_CREATED - Credit aangemaakt
                            case "9":
                              return "bg-secondary text-white"; // STATUS_READY - Gereed
                            default:
                              return "bg-light text-dark"; // Onbekend
                          }
                        })()} px-2 py-1 rounded-pill`}
                      >
                        {retour.status}
                      </span>
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        {retour.image ? (
                          <img
                            src={retour.image}
                            alt={retour.product_name}
                            className="mr-2"
                            style={{
                              width: "40px",
                              height: "40px",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <div
                            className="mr-2 d-flex align-items-center justify-content-center bg-light"
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "4px",
                            }}
                          >
                            <i className="fal fa-image text-muted fa-lg"></i>
                          </div>
                        )}
                        <div>
                          <div>{retour.product_name}</div>
                          <div className="d-flex align-items-center gap-2">
                            <ClientBadge clientId={retour.return_client_id} />{" "}
                            <small className="text-muted">
                              {retour.return_reason}
                            </small>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>{retour.product_ext_code}</td>
                    <td>
                      <div className="d-flex flex-column gap-2">
                        {/*
                        <button className="btn btn-outline-primary btn-sm">
                          Print retourlabel
                        </button>
                        */}

                        <button
                          className="btn btn-outline-secondary btn-sm"
                          onClick={(e) => {
                            e.stopPropagation();
                            this.toggleModal(retour);
                          }}
                        >
                          Status bekijken
                        </button>
                      </div>
                    </td>
                    <td>{parseFloat(retour.return_qty).toFixed(0)}</td>
                    <td>DOOS</td>
                    <td>
                      {new Date(retour.return_create_date).toLocaleDateString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </>
          ) : (
            <tbody>
              <tr>
                <td className="text-center py-4">Geen retouren gevonden</td>
              </tr>
            </tbody>
          )}
        </Table>

        <Modal
          isOpen={this.state.modal}
          toggle={() => this.toggleModal()}
          size="xl"
        >
          <ModalHeader toggle={() => this.toggleModal()}>
            Retour #{this.state.selectedRetour?.return_id}
          </ModalHeader>
          <ModalBody>
            {this.state.selectedRetour && (
              <div>
                <div className="retour-details">
                  <div className="product-image mr-3">
                    {this.state.selectedRetour.image ? (
                      <img
                        src={this.state.selectedRetour.image}
                        alt={this.state.selectedRetour.product_name}
                        style={{
                          width: "80px",
                          height: "80px",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <div className="placeholder-image">
                        <i className="fal fa-image"></i>
                      </div>
                    )}
                  </div>
                  <div className="">
                    <h4>{this.state.selectedRetour.product_name}</h4>
                    <div className="d-flex align-items-center gap-2 mb-3">
                      {this.state.selectedRetour.return_unit || "DOOS"}
                      <ClientBadge
                        clientId={this.state.selectedRetour.return_client_id}
                      />
                    </div>
                    {(this.state.selectedRetour.return_status === "2" ||
                      this.state.selectedRetour.return_status === "4") && (
                      <button
                        onClick={() =>
                          window.open(
                            this.getReturnLabelLink(
                              this.state.selectedRetour.return_id
                            ),
                            "_blank"
                          )
                        }
                        className="btn btn-outline-primary btn-sm"
                      >
                        Print retourlabel
                      </button>
                    )}
                  </div>
                  <div>
                    <div className="details">
                      <div className="detail-item">
                        <span className="label">Artikelnummer</span>
                        <span className="value">
                          {this.state.selectedRetour.product_ext_code}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="label">Eenheid</span>
                        <span className="value">
                          {this.state.selectedRetour.return_unit || "DOOS"}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="label">Aantal</span>
                        <span className="value">
                          {this.state.selectedRetour.return_qty}
                        </span>
                      </div>
                      {(() => {
                        const afgekeurdStatus = this.state.selectedRetour.statuses?.find(
                          (status) => status.name === "Afgekeurd"
                        );
                        return afgekeurdStatus ? (
                          <div className="detail-item">
                            <span className="label">Reden</span>
                            <span className="value">
                              {afgekeurdStatus.comment}
                            </span>
                          </div>
                        ) : null;
                      })()}
                    </div>
                  </div>
                </div>
                <h5 className="status-header">Status</h5>
                {this.renderStatusTimeline()}
              </div>
            )}
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default RetourenLijst;
